<div class="flex w-full flex-col p-5">
  <div class="mb-4 flex items-center justify-between">
    <h2 class="text-xl font-medium">Padarīto darbu pārskats</h2>
    <div class="shadow-xs inline-flex rounded-md">
      <button
        type="button"
        class="flex items-center gap-2 rounded-l-lg bg-green-700/10 px-3 py-2 text-sm transition-colors hover:bg-green-700/20 focus:z-10"
        (click)="downloadReport('darbu')"
      >
        Darbu eksports
        <mat-icon>download</mat-icon>
      </button>
      <div class="relative -ml-px block">
        <button
          type="button"
          class="relative inline-flex h-full items-center rounded-r-lg bg-green-700/10 px-2 py-2 transition-colors hover:bg-green-700/20 focus:z-10"
          id="option-menu-button"
          aria-expanded="true"
          aria-haspopup="true"
          (click)="toggleDropdown()"
        >
          <span class="sr-only">Open options</span>
          <svg data-slot="icon" fill="currentColor" viewBox="0 0 20 20" class="size-5" aria-hidden="true">
            <path
              clip-rule="evenodd"
              d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
              fill-rule="evenodd"
            />
          </svg>
        </button>

        @if (isDownloadDropdownOpen) {
          <div
            norupeClickOutside
            role="menu"
            tabindex="-1"
            class="focus:outline-hidden absolute right-0 z-10 -mr-1 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5"
            aria-labelledby="option-menu-button"
            aria-orientation="vertical"
            (clickOutside)="this.isDownloadDropdownOpen = false"
          >
            <div role="none" class="py-1">
              <button
                role="menuitem"
                tabindex="-1"
                type="button"
                class="flex w-full items-center justify-between gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-green-700/20"
                (click)="downloadReport('darbinieku')"
              >
                Darbinieku eksports
                <mat-icon class="text-base">download</mat-icon>
              </button>
              <button
                role="menuitem"
                tabindex="-1"
                type="button"
                class="flex w-full items-center justify-between gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-green-700/20"
                (click)="downloadReport('teritoriju')"
              >
                Teritoriju eksports
                <mat-icon class="text-base">download</mat-icon>
              </button>
              <button
                role="menuitem"
                tabindex="-1"
                type="button"
                class="flex w-full items-center justify-between gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-green-700/20"
                (click)="downloadReport('sejumu')"
              >
                Sējumu eksports
                <mat-icon class="text-base">download</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
      @if (overviewExportStore.loading()) {
        <div role="status">
          <svg
            fill="none"
            viewBox="0 0 100 101"
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
            aria-hidden="true"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      }
    </div>
  </div>
  @if (overviewStore.loading()) {
    <div role="status" class="flex justify-center">
      <svg
        fill="none"
        viewBox="0 0 100 101"
        xmlns="http://www.w3.org/2000/svg"
        class="h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
        aria-hidden="true"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span class="sr-only">Loading...</span>
    </div>
  }
  <div class="overflow-x-auto rounded-lg shadow" [hidden]="overviewStore.loading()">
    <table mat-table matSort class="mat-elevation-z8 w-full" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <th *matHeaderCellDef mat-header-cell>
          <mat-checkbox
            [aria-label]="checkboxLabel()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            (change)="$event ? toggleAllRows() : null"
          />
        </th>
        <td *matCellDef="let row" mat-cell>
          <mat-checkbox
            [aria-label]="checkboxLabel(row)"
            [checked]="selection.isSelected(row)"
            (change)="$event ? selection.toggle(row) : null"
            (click)="$event.stopPropagation()"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="assignedTo">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Darbinieks</th>

        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3">
          @let employee = employeeStore.entityMap()[element.assigned_to];
          {{ employee ? employee.first_name + " " + employee.last_name : "Nezināms darbinieks" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Resursa veids</th>
        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3">{{ resourceTypeStore.entityMap()[element.type].name }}</td>
      </ng-container>
      <ng-container matColumnDef="dateDone">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Datums</th>
        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3">{{ element.date_done | date: "dd.MM.yyyy" }}</td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Apjoms</th>
        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3">
          @if (element.report) {
            <button type="button" class="text-sm text-blue-600 hover:underline" (click)="openReportDialog(element.report)">Skatīt atskaiti</button>
          } @else {
            {{ element.value }}
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="unit">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Mērvienība</th>
        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3 font-bold">{{ element.unit }}</td>
      </ng-container>

      <ng-container matColumnDef="timeSpent">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Patērētās stundas</th>
        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3">{{ element.time_spent }}</td>
      </ng-container>

      <ng-container matColumnDef="job">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Darbs</th>
        <td
          *matCellDef="let element"
          mat-cell
          class="border-t px-4 py-3 text-blue-600 hover:cursor-pointer hover:text-blue-800 hover:underline"
          [routerLink]="['/job', element.job]"
        >
          {{ element.job_title }}
        </td>
      </ng-container>

      <ng-container matColumnDef="notes">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="bg-gray-50 px-4 py-3 font-medium text-gray-700">Piezīmes</th>
        <td *matCellDef="let element" mat-cell class="border-t px-4 py-3">{{ element.notes }}</td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row class="hover:bg-gray-50"></tr>
    </table>

    <mat-paginator class="border-t" aria-label="Select page of users" [pageSizeOptions]="[25, 50, 100]" (page)="onPageChange($event)" />
  </div>
</div>
